import { ActionsPerformanceMetricsChartProvider } from "../../../../../../contexts/actionsPerformanceMetricsChartContext";
import { Card } from "../../../../../../shared/components/card/Card";
import MetricsChartContainer from "./chart/MetricsChartContainer";

const DataContainer = ({
  params,
  metricsSelectables,
  groupedMetricsChartData,
  onGroupingDimensionChange,
  dimensionsSelectables,
  dateRange,
}) => {
  return (
    <Card className="min-h-[65vh] p-4">
      <ActionsPerformanceMetricsChartProvider>
        <MetricsChartContainer
          params={params}
          groupedMetricsChartData={groupedMetricsChartData}
          dateRange={dateRange}
          metricsSelectables={metricsSelectables}
          dimensionsSelectables={dimensionsSelectables}
          onGroupingDimensionChange={onGroupingDimensionChange}
        />
      </ActionsPerformanceMetricsChartProvider>
    </Card>
  );
};

export default DataContainer;
